import { render, staticRenderFns } from "./GeneralizeItem.vue?vue&type=template&id=643582a8&scoped=true&"
import script from "./GeneralizeItem.vue?vue&type=script&lang=js&"
export * from "./GeneralizeItem.vue?vue&type=script&lang=js&"
import style0 from "./GeneralizeItem.vue?vue&type=style&index=0&id=643582a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643582a8",
  null
  
)

export default component.exports